import axios, { InternalAxiosRequestConfig } from "axios";
import { cookie } from "../store/cookie";

const instance = axios.create({
  baseURL: "",
  timeout: 60000,
});

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (config.headers) {
    config.headers.Authorization = `Bearer ${cookie.get("token")}`;
  }

  return config;
});

export const http = instance;
